// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hydrogen-projects-tooltip .tooltip-title{font-weight:600;font-size:.875rem;line-height:.875rem}.hydrogen-projects-tooltip .tooltip-content{margin-top:8px}.hydrogen-projects-tooltip .tooltip-content span{font-weight:600}.hydrogen-projects-tooltip{font-size:.875rem;line-height:.95rem;font-family:Graphik}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
